import $ from "jquery";
import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import * as actions from "../../../actions/actions";

class IconShareModal extends React.Component {
    constructor(props) {
        super(props);
    }

    onShare(selectedIcon, event) {
        let $this;
        let description;
        let url;
        event.preventDefault();
        $this = $(event.target);

        url = "https://" + location.host + selectedIcon.permalink;
        if (selectedIcon.uploader.name === void 0) {
            description =
                "Check out " + selectedIcon.term + " icon on the @NounProject.";
        } else {
            description =
                "Check out " +
                selectedIcon.term +
                " icon designed by " +
                selectedIcon.uploader.name +
                " on the @NounProject.";
        }
        switch (true) {
            case $this.hasClass("ui_facebook"):
                this.href = $this.prop("href");
                this.href += "?u=" + url;
                this.share_setup(this.href);
                break;
            case $this.hasClass("ui_twitter"):
                this.href = $this.prop("href");
                this.href +=
                    "?text=" + encodeURIComponent(description) + "&url=" + url;
                this.share_setup(this.href);
                break;
            case $this.hasClass("ui_tumblr"):
                this.href = $this.prop("href");
                this.href +=
                    "?source=" + encodeURIComponent(selectedIcon.preview_url);
                this.href += "&caption=" + encodeURIComponent(description);
                this.href += "&click_thru=" + encodeURIComponent(url);
                this.share_setup(this.href);
                break;
            case $this.hasClass("ui_pinterest"):
                this.href = $this.prop("href");
                this.href +=
                    "?url=" +
                    url +
                    "&amp;media=" +
                    encodeURIComponent(selectedIcon.preview_url) +
                    "&amp;description=" +
                    description;
                this.share_setup(this.href);
        }
    }
    render() {
        return (
            <section id="share-modal" className="container">
                <div>
                    <header>
                        <h2>Where to Share?</h2>
                    </header>

                    <ul className="container social_links">
                        <li>
                            <a
                                href="https://www.facebook.com/sharer/sharer.php"
                                onClick={this.onShare.bind(
                                    this,
                                    this.props.icon
                                )}
                                type="button"
                                className="share-on-facebook ui_facebook"
                            />
                        </li>
                        <li>
                            <a
                                href="//twitter.com/share"
                                onClick={this.onShare.bind(
                                    this,
                                    this.props.icon
                                )}
                                type="button"
                                className="share-on-twitter ui_twitter"
                            />
                        </li>
                        <li>
                            <a
                                href="//www.tumblr.com/share/photo"
                                onClick={this.onShare.bind(
                                    this,
                                    this.props.icon
                                )}
                                type="button"
                                className="share-on-tumblr ui_tumblr"
                            />
                        </li>
                        <li>
                            <a
                                id="share-on-pinterest"
                                type="button"
                                href="//www.pinterest.com/pin/create/button/?url="
                                onClick={this.onShare.bind(
                                    this,
                                    this.props.icon
                                )}
                                className="ui_pinterest"
                            />
                        </li>
                    </ul>
                </div>
            </section>
        );
    }
    share_setup(href) {
        let width = 575,
            height = 400,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
                "status=1" +
                ",width=" +
                width +
                ",height=" +
                height +
                ",top=" +
                top +
                ",left=" +
                left;
        return window.open(href, "", opts);
    }
}

export default IconShareModal;
// being used in static/assets/js/constants/modalTypes.js
